/* eslint-disable no-case-declarations */
import { ColumnDirective, ColumnsDirective, CommandColumn, Edit, GridComponent, Inject, Sort, Toolbar } from '@syncfusion/ej2-react-grids';
import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useEffect, useState } from 'react';
import { confirm } from "react-confirm-box";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { DeleteAPIData, LoadAPIData, SaveAPIData } from '../../helpers/DataHelper';
import { EditCommandTemplate, ConfirmDialogStyles, SearchGridToolbar } from '../../helpers/Global';
import { ShowToast } from '../../helpers/Toast';
import { fieldRequired } from '../../helpers/validation';
import { useNavigate } from "react-router-dom";

export default function ShippingPrices() {
  const navigate = useNavigate();
  const [editData, setEditData] = useState();
  const [editId, setEditId] = useState(0);

  const [deliveryType, setDeliveryType] = useState(0);
  const [deliveryAmount, setDeliveryAmount] = useState(0);

  const [editModal, setEditModal] = useState(false);

  const toggle = () => setEditModal(!editModal);


  const commandClick = async (args) => {
    switch (args.commandColumn.type) {
      case 'Delete':
        if (await confirm("Are you sure you want to delete this item?", ConfirmDialogStyles)) {
          deleteItem(args.rowData.id);
        }
        break;
      default: //edit
        editItem(args.rowData.id);
        break;
    }
  }

  const loadData = async () => {
    setEditData(await LoadAPIData('/api/shippingprices'));
  }

  const addItem = () => { editItem(0); }

  const editItem = (id) => {
    if (id > 0) {
      const data = editData.find((item) => { return item.id === id });
      setEditId(data.id);

      setDeliveryType(data.deliveryType);
      setDeliveryAmount(data.deliveryAmount);
      

    }
    else {
      //clear state fields
      setEditId(0);

      setDeliveryType(1);
      setDeliveryAmount(0);
      
    }
    setEditModal(true);
  };

  const validateForm = () => {
    var valid = true;
    valid &= fieldRequired(deliveryAmount, 'tbDeliveryAmountError', '* required');

    return valid;
  }

  const saveItem = async (event) => {
    event.stopPropagation();

    if (validateForm()) {
      const data = { id: editId, deliveryType: deliveryType, deliveryAmount: deliveryAmount };

      const result = await SaveAPIData('/api/shippingprices', data, (editId === 0 ? 'POST' : 'PUT'));
      if (result.success) {
        loadData();
        ShowToast('Shipping Prices', 'The shipping price was successfully saved!', 'toast-success');
      }
      else {
        ShowToast('Shipping Prices', 'There was an error saving the shipping price!', 'toast-danger');
      }
      toggle();
    }
  }

  const deleteItem = async (dataId) => {
    const result = await DeleteAPIData('/api/shippingprices/' + dataId)
    if (result) {
      loadData();
      ShowToast('Shipping Prices', 'The shipping price was successfully deleted!', 'toast-success');
    }
    else {
      ShowToast('Shipping Prices', 'There was an error deleting the shipping price!', 'toast-danger');
    }
  }


  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-6 "><h1>Shipping Prices</h1></div>
        <div className="col-md-6 text-end align-self-center">
          <Button  color="dark" outline size="sm" data-recordid="0" onClick={e => navigate(-1)}><i className="fas fa-chevron-left mr-2"></i> Back To Admin</Button>
          <Button color="primary" size="sm" className="ms-2 d-none" onClick={addItem}>Add New <i className="fas fa-plus-circle ms-2"></i></Button>
        </div>
      </div>

      <GridComponent dataSource={editData} allowSorting={true}  commandClick={commandClick} >
        <ColumnsDirective>
          <ColumnDirective field='DeliveryType' width='100' headerText="Type" template={(props) => "Standard Delivery"} />
          <ColumnDirective field='DeliveryAmount' width='40' headerText="Price/Rate" />
          <ColumnDirective headerText='Actions' width='25' commands={EditCommandTemplate} />
        </ColumnsDirective>
        <Inject services={[Sort, Edit, CommandColumn, Toolbar]} />
      </GridComponent>

      <Modal isOpen={editModal} toggle={toggle} scrollable size="lg" backdrop="static">
        <ModalHeader toggle={toggle}>{editId === 0 ? "Add New" : "Edit"} Shipping Prices</ModalHeader>
        <ModalBody>
          <div className='mb-3 d-none'>
            <NumericTextBoxComponent id='tbDeliveryType' name='tbDeliveryType' placeholder='Delivery Type' floatLabelType='Auto' showClearButton={true} value={deliveryType} onChange={e => setDeliveryType(e.value)} />
            <div id='tbDeliveryTypeError' className='error-message' />
          </div>

          <div className='mb-3'>
            <NumericTextBoxComponent id='tbDeliveryAmount' name='tbDeliveryAmount' placeholder='Delivery Amount' min={0} step={ 1} floatLabelType='Auto' showClearButton={true} value={deliveryAmount} onChange={e => setDeliveryAmount(e.value)} />
            <div id='tbDeliveryAmountError' className='error-message' />
          </div>


        </ModalBody>
        <ModalFooter>
          <Button color="dark" size="sm" onClick={toggle}>Cancel <i className="far fa-times-circle ms-2"></i></Button>
          <Button color="success" size="sm" onClick={saveItem}>Save <i className="far fa-check-circle ms-2"></i></Button>
        </ModalFooter>
      </Modal>

    </>
  );
}

